module.exports = __webpack_public_path__ + "img/lk-double-down.b81a7da1.svg";